/**
 * Recuerda de donde llego la persona hasta que se registra.
 *
 * Sin esto no habia forma de atribuir un alta a nada: los enlaces de redes no
 * llevaban UTM, `users` no guardaba el origen y GA4 pierde a quien rechaza las
 * cookies. En agosto hubo
 * 67.833 visualizaciones de pago sin un solo registro demostrable.
 *
 * Solo se recuerda el origen de la campana (los cinco utm_*, el dominio que nos
 * enlazo y la pagina de entrada), nunca la URL completa ni nada que identifique
 * a la persona, y solo viaja al servidor junto al formulario de registro.
 *
 * Vive en memoria y NO en sessionStorage/localStorage a proposito: guardar algo
 * en el dispositivo que no es estrictamente necesario exige consentimiento (art.
 * 22.2 LSSI) y la politica de cookies promete que sin el no se guarda nada mas.
 * Pedirlo nos devolveria al punto de partida, porque quien rechaza las cookies
 * es justo a quien GA4 ya no ve. La navegacion de la web es SPA, asi que el
 * origen sobrevive del /sorteo al /register; se pierde al recargar, y es el
 * precio aceptado.
 *
 * Es el primer contacto de la sesion: si alguien entra desde Instagram y luego
 * navega por el blog, el alta se atribuye a Instagram.
 */
const UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
// Enlace de afiliado: ?aff=CODIGO en cualquier pagina, o la forma corta /a/CODIGO.
const RUTA_AFILIADO = /^\/a\/([A-Za-z0-9]{2,32})\/?$/;
const MAX = 64;

function limpiar(valor) {
    const v = String(valor || "").trim().toLowerCase().slice(0, MAX);
    return /^[a-z0-9._\-/]+$/.test(v) ? v : "";
}

function dominioQueEnlaza() {
    try {
        if (!document.referrer) return "";
        const host = new URL(document.referrer).hostname.replace(/^www\./, "");
        const propios = ["qcap.es", window.location.hostname.replace(/^www\./, "")];
        return propios.some((p) => host === p || host.endsWith(`.${p}`)) ? "" : limpiar(host);
    } catch (_e) {
        return "";
    }
}

let origenSesion = null;

export function capturarOrigen() {
    try {
        if (origenSesion) return;
        const params = new URLSearchParams(window.location.search);
        const origen = {};
        for (const k of UTM) {
            const v = limpiar(params.get(k));
            if (v) origen[k] = v;
        }
        const corto = window.location.pathname.match(RUTA_AFILIADO);
        const aff = limpiar(params.get("aff") || (corto && corto[1]));
        if (aff) origen.aff = aff;
        const referrer = dominioQueEnlaza();
        if (referrer) origen.referrer = referrer;
        const landing = limpiar(window.location.pathname);
        if (landing) origen.landing_path = landing;
        origenSesion = origen;
    } catch (_e) {
        // sin origen, el alta sigue igual
    }
}

export function leerOrigen() {
    return origenSesion && Object.keys(origenSesion).length ? { ...origenSesion } : null;
}

export function olvidarOrigen() {
    origenSesion = null;
}
